// User configurable options for Myob integration
export const MyobOptionTypes = {
  contactWriteSyncEnabled: 'contactWriteSyncEnabled',
  invoiceWriteSyncEnabled: 'invoiceWriteSyncEnabled',
  creditNoteWriteSyncEnabled: 'creditNoteWriteSyncEnabled',
  invoicePaymentReadSyncEnabled: 'invoicePaymentReadSyncEnabled',
  invoicePaymentWriteSyncEnabled: 'invoicePaymentWriteSyncEnabled',
  overpaymentWriteSyncEnabled: 'overpaymentWriteSyncEnabled',
  
  contactSyncStartDate: 'contactSyncStartDate',
  invoiceSyncStartDate: 'invoiceSyncStartDate',
  creditNoteSyncStartDate: 'creditNoteSyncStartDate',
  invoicePaymentSyncStartDate: 'invoicePaymentSyncStartDate',
  overpaymentSyncStartDate: 'overpaymentSyncStartDate'
}